import React, {useState} from "react";
import { Modal } from "@mui/material";
import styles from "./index.module.scss";
import close from "../../../assets/images/close-icon.svg";
import { helpLineVaraibles, FOOTER_TEXT } from "../../../constants/footerConstants.ts";
interface FooterProps {
  isHDBOnly?: boolean;
}

const Footer: React.FC<FooterProps> = ({
  isHDBOnly = false
}) => {
  const [showModal, setshowModal] = useState(false);

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.footerContent}>
        <div className={styles.text}>
          {FOOTER_TEXT.ALL_RIGHTS}
        </div>
        <div className={styles.textLine}>|</div>
        <div className={styles.text}>
          <span
            className={styles.contact}
            onClick={() => setshowModal(true)}
          >
            {FOOTER_TEXT.CONTACT_US}
          </span>
        </div>
      </div>
     { 
      <Modal open={showModal} onClose={() => setshowModal(false)} className={styles.modal}
      sx={{
    '&:focus-visible': {
      outline: 'none'
    },
    '& *:focus-visible': {
      outline: 'none'
    }
  }}>
        <div className={`${styles.modalContent} ${isHDBOnly ? styles.hdbModalContent : ""}`}>
         <div className={styles.modalHeader}> 
            <span>{FOOTER_TEXT.CONTACT_US_UPPERCASE}</span>
            <div className = {`${styles.horizontalgrayLine} ${isHDBOnly ? styles.smallGrayLine: ''}`}></div>
            <div>
              <img src={close} alt="close" className={styles.closeIcon} onClick={() => setshowModal(false)} />
            </div>
          </div>
         <div className={styles.modalBody}>
  {helpLineVaraibles.map((item, index) => (
    <>
      {(!isHDBOnly || (isHDBOnly && index == 1)) && (
        <div key={index} className={styles.helpLineItem}>
          <div className={styles.title}>{item.title}</div>
          <div className={styles.emailContainer}>
            <span className={styles.email}>{FOOTER_TEXT.EMAIL}</span>
            <a href={`mailto:${item.emailAddress}`} className={styles.emailLink}>
              {item.emailAddress}
            </a>
          </div>
          <div className={styles.numberContainer}>
            <span className={styles.number}>{FOOTER_TEXT.HELPLINE}</span>
            <a href={`tel:${item.helplineNumber}`} className={styles.phoneLink}>
              {item.helplineNumber}
            </a>
          </div>
          {item.timings && (
            <div className={`${styles.timings} ${isHDBOnly ? styles.hdbTimings : ''}`}>
              {item.timings}
            </div>
          )}
        </div>
      )}
      {index == 0 && !isHDBOnly && <div className={styles.grayLine}></div>}
    </>
  ))}
</div>
        </div>
      </Modal>
      }
    </footer>
  );
};

export default Footer;
